import { useEffect, useMemo } from 'react';
import { ScheduledTaskService } from '../services/scheduledTaskService';

export const useScheduledTasks = (scheduledTasks, moveTask, user) => {
    // Create service instance
    const scheduledTaskService = useMemo(() => {
        if (!user) return null;
        return new ScheduledTaskService(moveTask);
    }, [user, moveTask]);

    // Initialize service with tasks
    useEffect(() => {
        if (scheduledTaskService && scheduledTasks) {
            scheduledTaskService.initializeScheduledTasks(scheduledTasks);
        }
    }, [scheduledTaskService, scheduledTasks]);

    // Handle visibility changes
    useEffect(() => {
        if (!scheduledTaskService) return;

        const handleVisibility = () => {
            scheduledTaskService.handleVisibilityChange();
        };

        document.addEventListener('visibilitychange', handleVisibility);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibility);
        };
    }, [scheduledTaskService]);

    // Cleanup on unmount or user change
    useEffect(() => {
        return () => {
            if (scheduledTaskService) {
                scheduledTaskService.cleanup();
            }
        };
    }, [scheduledTaskService]);

    return scheduledTaskService;
};